module.exports = __webpack_public_path__ + "e947043cca343abec7ce38eff2281865.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-SemiBold.eot
 ** module id = 359
 ** module chunks = 9
 **/